import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../appUtils/axiosConfig";

const initialState = {

    isLoading: false,
    error: null,
    colors: [],
    activecolors: [],
    isColorsLoading: false

}


export const getColors = createAsyncThunk(
    'get_colors_page',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getColorsStart());
            const response = await axios.get(`/colors/get_colors.php`)
            console.log('response of colors', response?.data)
            if (response?.data?.status === 'success') {
                // Transform API data to UI format
                dispatch(getColorsSuccess(response?.data))
            }

            return response?.data?.data
        } catch (error) {
            dispatch(getColorsFailure(error.response.data.message))
        }
    }
)
export const getActiveColors = createAsyncThunk(
    'get_colors_page',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getActiveColorsStart());
            const response = await axios.get(`/colors/get_active_colors.php`)
            if (response?.status === 200) {
                // Transform API data to UI format
                dispatch(getActiveColorsSuccess(response?.data))
            }

            return response?.data
        } catch (error) {
            dispatch(getActiveColorsFailure(error.response.data.message))
        }
    }
)
export const addColor = createAsyncThunk(
    "addcolors",
    async (data, { dispatch, rejectWithValue }) => {
        const formData = new FormData();
        formData.append("title", data.title);
        formData.append("status", data.status);
        try {
            dispatch(addColorsStart());
            // Transform UI data to API format before sending
            const response = await axios.post(`/colors/add_color.php`, data);
            dispatch(addColorsSuccess(response.data?.user));
            if (response?.data?.status === 'success') {
                dispatch(getColors())
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }
            return response.data
        } catch (error) {
            dispatch(addColorsFailure(error.response.data.message));
            // SHOW_ERROR_NOTIFICATION(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);
export const deleteColor = createAsyncThunk('deletecolor', async (id, { dispatch, rejectWithValue }) => {
    try {
        dispatch(updateColorsStart());
        const response = await axios.delete(`/colors/delete_colors.php?id=${id}`);
        if (response?.data?.status === 'success') {
            dispatch(getColors())
            // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
        }
        return response.data
    } catch (error) {
        // SHOW_ERROR_NOTIFICATION(error.response.data.message);
        return rejectWithValue(error.response.data.message);
    }
})
export const updateColor = createAsyncThunk(
    "hsn/updateHsn",
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        console.log("Updating HSN — ID:", id, "Data:", data);

        try {
            dispatch(updateColorsStart());

            // Send to API as expected (id + payload)
            const response = await axios.post(`/colors/update_color.php`, {
                id,
                ...data,
            });

            if (response?.data?.status === "success") {
                dispatch(updateColorsSuccess(response.data?.hsn));
                dispatch(getColors()); // refresh list
            } else {
                dispatch(updateColorsFailure(response.data.message));
                return rejectWithValue(response.data.message);
            }

            return response.data;
        } catch (error) {
            const msg = error?.response?.data?.message || "Failed to update HSN";
            dispatch(updateColorsFailure(msg));
            return rejectWithValue(msg);
        }
    }
);

const colorsSlice = createSlice({
    name: 'colorsReducer',
    initialState,
    reducers: {
        getColorsStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getColorsSuccess(state, action) {

            state.colors = action.payload;
            state.isLoading = false;
        },
        getColorsFailure(state, action) {
            state.colors = null;
            state.isLoading = false;
            state.error = action.payload;

        },
        getActiveColorsStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getActiveColorsSuccess(state, action) {

            state.activecolors = action.payload;
            state.isLoading = false;
        },
        getActiveColorsFailure(state, action) {
            state.activecolors = null;
            state.isLoading = false;
            state.error = action.payload;

        },
        addColorsStart(state) {
            state.isColorsLoading = true;
            state.error = null;
        },
        addColorsSuccess(state, action) {
            state.user = action.payload;
            state.isColorsLoading = false;
        },
        addColorsFailure(state, action) {
            state.error = action.payload;
            state.isColorsLoading = false;
        },

        updateColorsStart(state) {
            state.isColorsLoading = true;
            state.error = null;
        },
        updateColorsSuccess(state, action) {
            state.user = action.payload;
            state.isColorsLoading = false;
        },
        updateColorsFailure(state, action) {
            state.error = action.payload;
            state.isColorsLoading = false;
        },
    }
})

export const { getColorsSuccess, getColorsStart, getColorsFailure, getActiveColorsSuccess, getActiveColorsStart, getActiveColorsFailure, addColorsStart, addColorsSuccess, addColorsFailure, updateColorsStart, updateColorsSuccess, updateColorsFailure } = colorsSlice.actions;

export default colorsSlice.reducer;